import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';

export interface IProofSubject {
  id: string;
  name: string;
  questions: string[];
}

interface IParams {
  selective_process_id: string;
  registration?: string;
}

const GetProofSubjects = async (params: IParams) => {
  if (!params.selective_process_id) return;

  const response = await configApi.get<IProofSubject[]>('candidate-area/subjects/', {
    params: {
      registration: params.registration,
    },
  });

  return response.data;
};

export const useGetProofSubjects = (params: IParams, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['get_proof_subjects', params?.selective_process_id],
    queryFn: () => GetProofSubjects(params),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled,
  });
};
